import _ from 'lodash';
import { routeCreator } from '@adrias-online/steiner/lib/helpers';

import helper from '../../../helpers/steinerHelper';
import routeRegister from '../../../helpers/routeRegister';
import { selectors } from '../reducers/cookies';

const routes = helper.generateRoutes('cookies', selectors);

routes.list.list.breadcrumb = 'Configurazione Cookie';

const list = _.values(routes.list).map(route => ({
    ...route,
    // hotelFilter: true,
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'cookies' */ `modules/cookies/${
                route.componentPath
                }`).then(response => resolve(response.default));
        });
    }
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('cookies', routes.patterns, {
    it: 'Cookies'
});
routeRegister.addLinks('cookies', links);

export default list;
